import { mapActions, mapGetters } from "vuex";
import withFormUtils from "./withFormUtils";
import withToasted from "./withToasted";

/**
 * Shortcut for new tag creation with VForm component.
 * Connected to Vuex, form methods/getters.
 */
export default {
  mixins: [withFormUtils, withToasted],

  methods: {
    /**
     * Method to be passed into ${tagFieldName} field.
     * @param tag
     */
    handleAddTag(tag) {
      const tagFormatted = {
        id: tag.key,
        name: tag.name,
        account_id: this.getAccount.id
      };

      let valueToUpd = [];
      const currentSelected = this.getValue("tags");

      if (currentSelected.length > 0) {
        valueToUpd = [...valueToUpd, ...Array.from(currentSelected)];
      }

      this.createTag({
        payload: tagFormatted,
        onSuccess: resp => {
          this.updateTags(resp);
          this.updateValue({
            formName: this.name,
            fieldName: "tags",
            value: [...currentSelected, resp.id]
          });
          this.toast(`Tag "${tag.name}" created succesfully!`);
        },
        onError: () => this.toast("Tag haven't created!", "error")
      });
    },

    handleDeleteTag(tag) {
      this.deleteTag({
        tagId: tag.key,
        onSuccess: resp =>
          this.toast(`Tag "${tag.label}" deleted succesfully!`),
        onError: () => this.toast("Tag haven't created!")
      });
    },

    ...mapActions("tags", [
      "updateTags",
      "createTag",
      "deleteTag"
    ])
  },

  computed: {
    ...mapGetters("account", ["getAccount"])
  }
};
